"use client";

import Link from "next/link";

function Card({ title, children }) {
  return (
    <div className="rounded-2xl border border-border bg-surface/60 p-4">
      <h2 className="text-base font-semibold text-textPrimary">{title}</h2>
      <div className="mt-3 space-y-2 text-sm text-textPrimary">{children}</div>
    </div>
  );
}

export default function CreatorEbooksPromoPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-6 sm:px-6 lg:px-8 text-textPrimary">
      <div className="mb-5">
        <div className="flex items-center justify-between gap-3">
          <h1 className="text-2xl font-semibold">Ebook creator guidelines</h1>

          <Link
            href="/creator/ebooks/new"
            className="inline-flex items-center justify-center rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-black hover:opacity-90 shadow-glowPrimary"
          >
            Upload ebook
          </Link>
        </div>

        <p className="mt-2 text-sm text-textPrimary">
          Promotion rules + revenue split for ebooks on ReloadPi.
        </p>
      </div>

      <div className="space-y-4">
        <Card title="Creator tools & promotion (Fireside Forum)">
          <p>
            ReloadPi may provide limited visibility support on the{" "}
            <strong className="text-textPrimary">Fireside Forum</strong>. To be
            considered, creators must first publish their own promotional post in{" "}
            <strong className="text-textPrimary">Pi Commerce</strong>.
          </p>

          <p>
            All posts must comply with Pi Network rules. This means:
            <strong className="text-textPrimary"> no personal information</strong>, no
            personal email addresses, no Telegram channels, and no external
            contact details.
          </p>

          <p>
            Your promotional post must include a direct link to your book page on
            ReloadPi:
          </p>

          <p className="font-mono text-xs break-all text-textPrimary">
            https://reloadpi.com/ebooks/&lt;your-book-link&gt;
          </p>

          <p>
            After publishing your post, email{" "}
            <strong className="text-textPrimary">promo@reloadpi.com</strong> with the
            link to your forum post.
          </p>

          <p className="text-xs text-textPrimary">
            ReloadPi will briefly support publications that meet all requirements.
          </p>
        </Card>

       <Card title="Revenue & payments">
  <p>
    Sales processed on reloadpi.com use a{" "}
    <strong className="text-textPrimary">70% / 30%</strong> revenue split.
  </p>

  <p>
    Book creators receive{" "}
    <strong className="text-textPrimary">70%</strong>. ReloadPi retains{" "}
    <strong className="text-textPrimary">30%</strong> to support platform
    hosting, maintenance, and operations.
  </p>

  <p>
    Payments may be completed using supported cryptocurrencies, including{" "}
    <strong className="text-textPrimary">Pi Coin</strong> and{" "}
    <strong className="text-textPrimary">USDC via FogoChain</strong>.
  </p>

<p>
  Creators can optionally input pricing in{" "}
  <strong className="text-textPrimary">Pi Coin</strong>, which is{" "}
  <strong className="text-textPrimary">highly recommended</strong> to ensure
  consistent pricing across users from different ecosystems.
</p>

<p>
  ReloadPi handles all payment processing and currency conversion automatically.
  A{" "}
  <strong className="text-textPrimary">5% conversion fee</strong> applies when a
  payment is completed in{" "}
  <strong className="text-textPrimary">Pi Coin</strong> but the creator does not
  have a Pi-supported wallet, or when the settlement currency differs from the
  listed price.
</p>


  <p className="text-xs text-textPrimary">
    This revenue and conversion model applies to all eligible ebook sales completed
    on the ReloadPi platform.
  </p>
</Card>
 <div className="flex gap-3 pt-2">
          <Link
            href="/ebooks"
            className="text-sm text-primary underline underline-offset-4"
          >
            Back to ebooks marketplace
          </Link>
        </div>
      </div>
    </div>
  );
}
